import { useEffect, useMemo, useState } from 'react'
import { Token, TokenAmount } from 'symbiosis-js-sdk'
import { BigNumber } from 'ethers'
import { symbiosis } from '~/lib/symbiosis'
import { getChainConfig } from '~/lib/config'

const omniPoolConfig = symbiosis.config.omniPools[0]

export const useUserLiquidity = (
	account: string | null | undefined
): [boolean, TokenAmount[]] => {
	const pool = useMemo(() => {
		return symbiosis.omniPool(omniPoolConfig)
	}, [])

	const poolOracle = useMemo(() => {
		return symbiosis.omniPoolOracle(omniPoolConfig)
	}, [])

	const [state, setState] = useState<{
		loading: boolean
		balances: TokenAmount[]
	}>({ loading: false, balances: [] })

	const load = async (userAddress: string) => {
		const lastIndex = await pool.lastIndex()

		const promises = Array.from(Array(lastIndex.toNumber()).keys()).map(
			(index) => {
				return pool.indexToAsset(index)
			}
		)

		const assets = await Promise.all(promises)

		const balancePromises = assets.map((asset, i) => {
			return pool.balanceOf(userAddress, i)
		})
		const balances = await Promise.all(balancePromises)

		const withdrawPromises = assets.map((asset, i) => {
			if (balances[i].eq(0)) {
				return { amount: BigNumber.from(0) }
			}
			return poolOracle.quoteWithdraw(i, balances[i])
		})
		const withdrawals = await Promise.all(withdrawPromises)


		return assets
			.map((asset, i) => {
				const found = symbiosis.tokens().find(
					(stable) =>
						stable.address.toLowerCase() ===
						asset.token.toLowerCase()
				)
				if (!found) {
					return undefined
				}
				if (withdrawals[i].amount.eq('0')) {
					return undefined
				}
				return new TokenAmount(found, withdrawals[i].amount.toString())
			})
			.filter((i) => !!i) as TokenAmount[]
	}

	useEffect(() => {
		if (!account) {
			return
		}
		setState({ loading: true, balances: [] })

		load(account).then((balances) => {
			setState({ loading: false, balances })
		})
	}, [account])

	return [state.loading, state.balances]
}
